import { createPersistedToggle } from "./persisted-toggle";

/** Hover/selection inspection is separate from annotations pinned by View. */
export const useCableHoverDetails = createPersistedToggle("twelve-volt:cable-hover-details", true);
